






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Header from '@/shared/components/Layout/Header.vue';
import Footer from '@/shared/components/Layout/Footer.vue';

@Component({
  components: {
    Header,
    Footer,
  }
})
export default class FullTemplate extends Vue {
  @Prop({ default: false }) private fillHeight!: boolean;
}
